<template>
    <div class="complaints">
        <h2>Назначение инструментальных исследований</h2>

        <div class="complaints-filters">
            <!-- <v-autocomplete
                label=""
                placeholder="Выберите группу"
                item-value="id"
                item-text="name"
                multiple
                outlined
                clearable
                hide-details
                @change="selectedGroup"
                v-model="params.groupIds"
                :loading="loadListGroup"
                :items="listGroup"
            /> -->
            <AutocompleteComponents
                :loading="loadListGroup || loading"
                :items="listGroup"
                :clearable="true"
                :multiple="true"
                item-text="name"
                placeholder="Выберите группу"
                @change="selectedGroup"
                @hideOrShowGroup="viewOrNot"
                :optionsApi="{ url: 'DiaTest/UpdateInstrumentalResearchesVisible' }"
            />

            <v-autocomplete
                label=""
                :placeholder="isDisabledProperty ? 'Выберите группу для отображения показателей' : 'Выберите показатель'"
                item-value="id"
                clearable
                item-text="name"
                multiple
                outlined
                @change="filter(false, true)"
                hide-details
                v-model="params.propertyIds"
                :disabled="isDisabledProperty"
                :items="listProperty"
            />
        </div>

        <div class="complaints-filters">
            <v-checkbox
                v-model="getVirtualPatient.isInstrumentalTakeOrder"
                label="Учитывать порядок"
                color="primary"
                class="itemCheckBox"
                :disabled="loadingOrder || getFlagReadonly"
                @change="setOrderState($event)"
            />

            <v-checkbox v-model="viewOpenIndicators" @change="showOnlyOpenIndicators(viewOpenIndicators)" label="Показать только открытые показатели" />
        </div>


        <div class="scroll">
            <div v-show="!loading" v-for="(el, key) in getDiagnostic.instrumental" :key="key" class="lab-item">
                <div class="item-line">
                    <div class="item-combo">
                        <p>Группа</p>
                        <input :disabled="!el.isVisible" v-model="el.groupName" readonly type="text">
                    </div>
                    <div class="item-combo">
                        <p>Наименование</p>
                        <input :disabled="!el.isVisible" v-model="el.propertyName" readonly type="text">
                    </div>
                </div>
                <div class="item-line">
                    <div class="item-combo">
                        <p>Значение</p>
                        <input :disabled="!el.isVisible" v-show="!el.edite && el.valueType === 0" :value="el.avgValue" readonly type="number">
                        <input :disabled="!el.isVisible" v-show="!el.edite && el.valueType === 1" :value="el.listValueName" readonly type="text">

                        <input
                            :disabled="!el.isVisible"
                            v-show="el.edite && el.valueType === 0"
                            v-model="el.avgValue"
                            :ref="`input-${el.id}${key}`"
                            type="number"
                            @input="save({ obj: el, url: 'DiaTest/AddOrUpdateInstrumentalResearch' }, true)"
                        >

                        <v-autocomplete
                            label=""
                            hide-details
                            :disabled="!el.isVisible"
                            v-show="el.edite && el.valueType === 1"
                            outlined
                            height="46"
                            :items="el.listValues"
                            :loading="el.loadSpr"
                            @change="save({ obj: el, url: 'DiaTest/AddOrUpdateInstrumentalResearch' }, true); setListValue(el)"
                            :placeholder="el.loadSpr ? 'Данные подгружаются из справочника...' : 'Выбрать значение'"
                            :no-data-text="el.loadSpr ? 'Ждите, данные подгружаются из справочника...' : 'Отсутствуют данные'"
                            item-text="name"
                            item-value="id"
                            class="item-combo__select"
                            v-model="el.listValueId"
                        />
                    </div>
                    <div class="item-combo" v-if="el.valueType === 0">
                        <p>Единица измерения</p>
                        <input :disabled="!el.isVisible" v-model="el.measurementName" readonly type="text">
                    </div>
                </div>
                <div class="item-line item-btn">
                    <div class="item-combo btn-horiz">
                        <div class="switch horiz mb-0">
                            <p>Патология</p>
                            <div class="switch-item">
                                <span>Нет</span>
                                <v-switch
                                    disabled
                                    v-model="el.isPathology"
                                    :loading="el.loadPatalogy"
                                    @change="switchIsVisibleOrPatalogy({ obj: el, url: 'DiaTest/AddOrUpdateInstrumentalResearch' }, 'loadPatalogy', null)"
                                />
                                <span>Да</span>
                            </div>
                        </div>

                        <div class="switch horiz mb-0 pt-3">
                            <v-checkbox v-model="el.isRequired" @change="save({ obj: el, url: 'DiaTest/AddOrUpdateInstrumentalResearch' }, false)"  :disabled="!el.isVisible || getFlagReadonly" label="Обязательно" color="primary" class="itemCheckBox" />
                        </div>
                    </div>
                    <div class="item-combo right">
                        <v-btn
                            class="btn-load__edite custom-button"
                            height="46"
                            x-small
                            :class="{ 'btn-load__disabled': !el.isVisible }"
                            type="button"
                            :loading="el.loadMedia"
                            @click.prevent="addMedia(el)"
                        >
                        {{ getFlagReadonly ? 'Посмотреть прикрепленные файлы' : 'Прикрепить файл' }}
                        </v-btn>
                        <v-autocomplete
                            hide-details
                            label=""
                            :disabled="loadingOrder || getFlagReadonly"
                            v-show="getVirtualPatient.isInstrumentalTakeOrder && orderReset"
                            outlined
                            :items="getDiagnostic.sortList"
                            :loading="loadingOrder"
                            class="item-combo__menu"
                            v-model="el.ord"
                            @change="updateOrder(el)"
                        />
                        <v-btn
                            v-if="!getFlagReadonly"
                            :loading="el.loadVisible"
                            @click="switchIsVisibleOrPatalogy({ obj: el, url: 'DiaTest/AddOrUpdateInstrumentalResearch' }, 'loadVisible', 'isVisible')"
                            class="btn-load__view"
                            height="46"
                            :title="el.isVisible ? 'Скрыть' : 'Показать'"
                        >
                            <v-icon> {{ !el.isVisible ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                        </v-btn>

                        <v-btn
                            v-if="!getFlagReadonly"
                            :loading="el.loadSpr"
                            :disabled="!el.isVisible"
                            class="custom-button"
                            @click="getData(el, key, 'SprInstrumentalResearch')"
                            :class="{
                                'btn-load__edite': true,
                                'btn-load__disabled': !el.isVisible
                            }"
                            height="46"
                            :title="el.edite ? 'Закрыть' : 'Редактировать'"
                        >
                            <v-icon> {{ el.edite ? 'mdi-close' : 'mdi-pencil' }}</v-icon>
                        </v-btn>
                    </div>
                </div>
            </div>

            <Observer v-if="isDataInstrumental > 0 && !loading">
                <template slot="showMore">
                    <div class="text" @click="showMoreFunc(params)">
                        <span class="text__info" v-if="showMoreFinish">
                            Всего записей: {{ isDataInstrumental }}
                        </span>
                        <span class="text__btn" v-else>
                            Показать еще {{ params.pageSize }}
                        </span>

                        <v-overlay :value="loadingShowMore" absolute opacity="0.2">
                            <v-progress-circular indeterminate size="25" />
                        </v-overlay>
                    </div>

                </template>
            </Observer>

            <div
                v-show="loading"
                v-for="(el, key) in 2"
                :key="'B'+key"
                class="skeleton"
            >
                <v-skeleton-loader type="article, actions" />
            </div>
        </div>

        <TimeoutSnackbar :options="snackbar" />
    </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import debounce from 'lodash.debounce';
import TimeoutSnackbar from '@/components/TimeoutSnackbar.vue';
import Observer from '@/components/VirtualScroll/index.vue';
import AutocompleteComponents from '@/components/Autocomplete/index.vue';

export default {
    name: 'laboratory',
    props: {
        name: String
    },
    components: {
        TimeoutSnackbar,
        Observer,
        AutocompleteComponents
    },
    computed: {
        ...mapGetters({
            apiGuide: 'apiGuide',
            api: 'apiUrl',
            getVirtualPatient: 'createDiagnosticTest/getVirtualPatient',
            getDiagnostic: 'createDiagnosticTest/getDiagnostic',
            getFlagReadonly: 'createDiagnosticTest/getFlagReadonly',
            mediaData: "media/mediaData",
        }),
        isDisabledProperty() {
            let groupIds = this.params.groupIds;

            if(groupIds && groupIds.length > 0) {
                return false;
            }

            return true
        },
        isDataInstrumental() {
            if(this.getDiagnostic.instrumental && this.getDiagnostic.instrumental.length > 0) {
             return this.getDiagnostic.instrumental.length
            }

            return 0
        }
    },
    data:() => ({
        loading: true,
        viewOpenIndicators: false,
        loadingOrder: false,
        orderReset: false,
        snackbar: {
            show: false,
            text: null,
            color: null,
            timeout: -1
        },
        params: {
            groupIds: [],
            propertyIds: [],
            pageSize: 5,
            currentPage: 0
        },
        totalRecords: 0,
        loadingShowMore: false,
        showMoreFinish: false,
        listGroup: [],
        listProperty: [],
        loadListGroup: true
    }),
    methods: {
        ...mapMutations({
            changeFlagMissingStep: 'createDiagnosticTest/changeFlagMissingStep',
            changeFlagAddMedia: 'createDiagnosticTest/changeFlagAddMedia',
            changeFlagConstructor: 'createDiagnosticTest/changeFlagConstructor',
            mediaFilter: "media/mediaFilter",
            changeFilterMedia: "createDiagnosticTest/changeFilterMedia",
            selectPropertyInstrumental: "createDiagnosticTest/selectPropertyInstrumental",
            saveResearches: 'createDiagnosticTest/saveResearches'
        }),
        ...mapActions({
            saveVirtualInformation: 'createDiagnosticTest/saveVirtualInformation',
            getResearchesByTestId: 'createDiagnosticTest/getResearchesByTestId',
            saveInline: 'createDiagnosticTest/saveInline',
            getSprInstrumentalResearch: 'createDiagnosticTest/getSprInstrumentalResearch',
            getMediaForInstrumental: 'createDiagnosticTest/getMediaForInstrumental',
            getFiles: 'media/getFiles'
        }),
        save: debounce( function (obj, updateValue) {
            this.saveInline(obj)
                .then((data) => {
                    if (updateValue) obj.obj.isPathology = data.isPathology;
                    obj.obj.edite = false;
                    this.snackbar = { text: 'Изменения сохранены успешно!', color: 'success', timeout: 3000, show: true };
                })
                .catch((error) => {
                    if(error) {
                        // console.log(error);
                        this.snackbar = { text: 'Ошибка сохранения данных, обратитесь к Администратору!', color: 'error', timeout: 3000, show: true };
                    }
                });
        }, 1500),
        setListValue(item) {
            let listValue = item.listValues.find(x => x.id === item.listValueId);

            if (listValue) {
                item.listValueName = listValue.name;
            }
        },
        setOrderState(state) {
            this.loadingOrder = true;
            this.getVirtualPatient.isInstrumentalTakeOrder = state;

            this.saveVirtualInformation(this.getVirtualPatient)
                .then(() => {
                    this.loadingOrder = false;
                    this.resetOrder(true);
                });
        },
        resetOrder(update) {
            if (!this.getVirtualPatient.isInstrumentalTakeOrder) {
                return;
            }

            this.loadingOrder = true;

            this.$http.post(`${this.api}DiaTest/AddInstrumentalResearchesFromEpisode?testId=${this.$route.params.id}&resetOrder=${update}`)
                .then(() => {
                    this.loadingOrder = false;
                    this.orderReset = true;

                    if (update) {
                        this.filter(false, false);
                    }
                });
        },
        updateOrder(item) {
            this.$http.post(`${this.api}DiaTest/UpdateInstrumentalResearchOrder?id=${item.id}&newOrder=${item.ord}`)
                .then(() => {
                    this.filter(false, false);
                });
        },
        switchIsVisibleOrPatalogy(obj, nameLoad, nameVal) {
            obj.obj[nameLoad] = true;
            if(nameVal) obj.obj[nameVal] = !obj.obj[nameVal];

            this.saveInline(obj)
                .then(() => {
                    obj.obj[nameLoad] = false;
                    this.snackbar = { text: 'Изменения сохранены успешно!', color: 'success', timeout: 3000, show: true };

                    if(nameVal == 'isVisible') {
                        for (let i = 0; i < this.listGroup.length; i++) {
                            if(!this.listGroup[i].isVisible && obj.obj.isVisible && this.listGroup[i].id === obj.obj.groupId) {
                                this.listGroup[i].isVisible = true;
                            }
                        }
                    }
                })
                .catch((error) => {
                    if(error) {
                        this.snackbar = { text: 'Ошибка сохранения данных, обратитесь к Администратору!', color: 'error', timeout: 3000, show: true };
                    }
                })
        },
        getData(item, index, url) {
            item.edite = !item.edite;

            this.$nextTick(() => {
                if(item.valueType === 1) {
                    if(item.edite) {
                        item.loadSpr = true;
                        // Список для значения
                        this.$http.get(`${this.apiGuide}api/${url}/GetListValues?propertyId=${item.propertyId}`)
                            .then((res) => {
                                this.$refs[`input-${item.id}${index}`][0].focus();
                                item.listValues = res.data;
                                item.loadSpr = false;
                            })
                    }
                } else {
                    this.$refs[`input-${item.id}${index}`][0].focus();
                }
            })
        },
        selectedGroup(event) {
            if(!event || event.length === 0){
                this.listProperty = [];
                this.params.groupIds = [];
                this.params.propertyIds = [];
                this.filter(false, true);

                return;
            }

            this.params.groupIds = event;
            this.listProperty = [];

            for (let i = 0; i < event.length; i++) {
                for (let j = 0; j < this.listGroup.length; j++) {
                    if(event[i] === this.listGroup[j].id) {
                        this.listProperty.push(...this.listGroup[j].indicators)
                    }
                }
            }

            this.filter(false, true);
        },
        filter(showMore, reset) {
            if(reset) {
                this.loading = true;
                this.saveResearches({ data: [], name: 'instrumental', showMore: false, totalRecords: 0 });
                this.params.currentPage = 0;
            }

            return new Promise((resolve, reject) => {
                this.getResearchesByTestId({
                    testId: this.$route.params.id,
                    url: 'DiaTest/GetInstrumentalResearches',
                    name: 'instrumental',
                    params: this.params,
                    showMore: showMore
                })
                .then((res) => {
                    if(res.totalRecords === this.isDataInstrumental) {
                        this.showMoreFinish = true;
                    } else {
                        this.showMoreFinish = false;
                    }

                    this.totalRecords = res.totalRecords;
                    this.loading = false;
                    resolve(res);
                })
                .catch((error) => {
                    reject(error)
                    this.loading = false;
                })
            })
        },
        showMoreFunc(params) {
            if(this.showMoreFinish) {
                return;
            }

            this.loadingShowMore = true;
            params.currentPage++;

            this.filter(true, false)
                .then(() => {
                    this.loadingShowMore = false;
                })
        },
        viewOrNot(event) {
            this.params.groupIds = event;
            this.loading = true;
            this.filter(false, true);
        },
        addMedia(element) {
            element.loadMedia = true;

            this.getMediaForInstrumental({
                testId: this.$route.params.id,
                propertyId: element.propertyId,
                sectionId: '00000000-0000-0000-0000-000000000010'
            })
            .then(() => {
                element.loadMedia = false;
                this.selectPropertyInstrumental(element);
                this.changeFlagConstructor({ name: 'flagInstrumental', value: true });
            })
            .catch((error) => {
                if(error) {
                    element.loadMedia = false;
                    this.snackbar = { text: 'Ошибка при получении файлов, обратитесь к Администратору!', color: 'error', timeout: 3000, show: true };
                }
            })
        },
        showOnlyOpenIndicators(value) {
            this.loadAll = true;
            this.params.isVisible = value;

            this.getSprInstrumentalResearch({testId: this.$route.params.id, isVisible: value })
                .then((response) => {
                    this.listGroup = response;
                    this.loadListGroup = false;
                    this.filter(this.isDataLabaratory > 0, true);
                });
        }
    },
    destroyed() {
        this.changeFlagConstructor({ name: 'flagInstrumental', value: false });
        this.selectPropertyInstrumental(null);
    },
    created() {
        // Если предыдущая нумерация пропущена и у этой нумерации состояние 1/3 то вызываем окно с подтверждением
        if(this.getDiagnostic.methods === 'skip' && this.getDiagnostic.levels[9].visibleType !== 2) {
            this.changeFlagMissingStep({ flag: true, index: 9 });
        }

        this.getSprInstrumentalResearch({testId: this.$route.params.id, isVisible: this.viewOpenIndicators })
            .then((response) => {
                this.listGroup = response;
                this.loadListGroup = false;
            });

        if (!this.getFlagReadonly) {
            this.resetOrder(false);
        } else {
            this.orderReset = true;
        }

        this.filter(false, true);
    }
}
</script>
